module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.deno/babel-runtime@6.26.0/~/babel-runtime/core-js/symbol.js
// module id = 183
// module chunks = 0